import API from '../../api';

const types = {
  GET_SIMS_SUCCESS: 'GET_SIMS_SUCCESS',
  GET_SIMS_ERROR: 'GET_SIMS_ERROR',
}

const state = {
  all: []
}

const getters = {
  byCardNo: state => cardNo => {
    return state.all.find(item => item.card_no == cardNo);
  },

  byPhone: state => phone => {
    return state.all.find(item => item.phone == phone);
  },

  find: state => params => {
    return state.all.find(item => {
      return (params.phone ? item.phone == params.phone : false) ||
             (params.card_no ? item.card_no == params.card_no : false)
    });
  },
}

const actions = {
  get({ commit }, params) {
    return API.sims.get(params).then(response => {
      commit(types.GET_SIMS_SUCCESS, response.data.result);
      return response;
    }).catch(error => {
      commit(types.GET_SIMS_ERROR);
    });
  },
}

const mutations = {
  [types.GET_SIMS_SUCCESS](state, issues) {
    state.all = issues;
  },

  [types.GET_SIMS_ERROR](state) {
    state.all = [];
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
